<template>
    <div>
        <section class="my-4">
            <v-card>
                <v-list two-line subheader>
                    <v-subheader>
                        {{ heading }}
                        <router-link v-if="heading!=`Zugeordnete Dokumente`" :to="'/contract/'+contract.id" class="opencontractchatlink" title="Vertrag öffnen">
                            <v-icon right>open_in_new</v-icon>
                        </router-link>
                    </v-subheader>
                    <v-list-tile v-for="file in docs.slice(10*(current_page-1), 10*current_page)" :key="file.id" avatar>
                        <v-list-tile-avatar>
                            <v-icon v-if="isImage(file.mime)" class="amber white--text">photo</v-icon>
                            <v-icon v-if="file.mime=='pdf'" class="red white--text">picture_as_pdf</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content v-if="isImage(file.mime)" @click="file_modal_item = file">
                            <v-list-tile-title>{{ file.name }}</v-list-tile-title>
                            <v-list-tile-sub-title>vom: {{ file.published_date | moment("DD.MM.YYYY") }}</v-list-tile-sub-title>
                            <v-progress-linear v-if="file.progress" :value="file.progress" height="5" color="black"></v-progress-linear>
                        </v-list-tile-content>

                        <v-list-tile-content v-else>
                            <a :href="file.url" target="_blank" :download="file.name" class="d-block w-100">
                                <v-list-tile-title>{{ file.name }}</v-list-tile-title>
                                <v-list-tile-sub-title>vom: {{ file.published_date | moment("DD.MM.YYYY") }}, {{ file.published_date | moment("HH:mm") }}Uhr</v-list-tile-sub-title>
                                <v-progress-linear v-if="file.progress" :value="file.progress" height="5" color="black"></v-progress-linear>
                            </a>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-menu bottom left>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile :ripple="{ class: 'black--text' }" @click="getFilenameRewriteModal(file)">
                                        <v-list-tile-title><v-icon left>edit_attributes</v-icon> Umbenennen</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile :ripple="{ class: 'black--text' }" :href="file.url" target="_blank">
                                        <v-list-tile-title><v-icon left>open_in_new</v-icon> Im neuen Tab öffnen</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>

                <v-tooltip left>
                    <template v-slot:activator="{ on }">
                          <v-btn absolute dark fab bottom right color="black" v-on="on" @click="$refs.docUploadInput.click()"><v-icon>add</v-icon></v-btn>
                    </template>
                    <span>Dokumente hinzufügen</span>
                </v-tooltip>
            </v-card>

            <footer>
                <v-pagination v-if="total_pages>1" v-model="current_page" :length="total_pages" circle class="my-3" color="black"></v-pagination>
            </footer>
        </section>


        <LightBox :file_modal_item="file_modal_item" />


        <input type="file" ref="docUploadInput" @change="onFileChanged" accept="application/pdf, image/*" multiple hidden />


        <v-bottom-sheet v-model="filename_modal_show" lazy inset>
            <v-card class="pa-3" tile>
                <v-form ref="filename_modal_form" lazy-validation @submit.prevent="setFilename">
                    <v-layout row wrap justify-center>
                        <v-text-field
                            ref="filename_modal_item_name"
                            type="text"
                            v-model="filename_modal_item_name"
                            :rules="[() => !!filename_modal_item_name || 'Pflichtfeld - Bitte ausfüllen', () => !!filename_modal_item_name && filename_modal_item_name.length >= 3 || 'Die Dateibezeichnung sollte aus mind. 3 Zeichen bestehen']"
                            label="Dokumentenbezeichnung *"
                            maxlength="60"
                            clearable
                            required
                        />
                    </v-layout>
                    <v-card-actions class="pa-0">
                        <v-btn flat color="secondary" @click="filename_modal_show = false">Abbrechen</v-btn>
                        <v-spacer />
                        <v-btn color="black" @click="setFilename" dark>Speichern</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-bottom-sheet>
    </div>
</template>


<script>
import LightBox from '@/components/LightBox'


export default {
    name: 'ContractDocumentsCard',

    data: () => ({
            file_modal_item: {},
            filename_modal_show: false,
            filename_modal_form: true,
            filename_modal_item: null,
            filename_modal_item_name: '',
            current_page: 1,
            total_pages: 1
        }
    ),


    components: {
        LightBox
    },


    props: {
        contract: {
            type: Object,
            default: () => ({})
        },
        heading: {
            type: String,
            default: `Zugeordnete Dokumente`
        }
    },

    computed: {
        docs(){
            let docs_tmp = _.reverse(this.$store.getters['files/getFilesByContract'](this.contract.id));
            this.total_pages = Math.ceil(docs_tmp.length / 10);
            return docs_tmp;
        }
    },


    methods: {

        isImage(mime){
            return mime=='jpg' || mime=='jpeg' || mime=='png' || mime=='svg' || mime=='gif' || mime=='webp';
        },

        setFilename(){
            this.filename_modal_item.name = this.filename_modal_item_name;
            this.$store.dispatch('files/setFilename', {file_id: this.filename_modal_item.id, name: this.filename_modal_item.name});
            this.$snotify.success('Dateiname wurde erfolgreich geändert');
            this.filename_modal_show = false;
        },

        getFilenameRewriteModal(fileobj){
            this.filename_modal_item = fileobj;
            this.filename_modal_item_name = fileobj.name;
            this.filename_modal_show = true;
        },

        onFileChanged (event) {
            this.current_page = 1;
            Array.from(event.target.files).forEach(file => {
                //console.log(file);
                if(file.type.search("image")<0 && file.type != "application/pdf"){
                    this.$snotify.warning('Der Dateityp wird zZt. nicht unterstützt!', 'Warning');
                    return false;
                }
                this.uploadFile(file);
                return true
            });
        },

        uploadFile(file){
            if(file){
                this.$store.dispatch('files/uploadFile', {uploadfile: file, fileobject: {contract_id: this.contract.id, type: 'attachment'}}).then(fileobject => {
                    this.$store.dispatch('chat/setTodo', {
                        type: `NEW_DOC`,
                        subject: `Neues Dokument vom Kunden`,
                        content: `Der Kunde hat ein neues Dokument hochgeladen: ${fileobject.name}.`,
                        cid: this.contract.id
                    });
                });
            }
        },

    }
}
</script>


<style scoped>
    .v-list.v-list--two-line .v-list__tile.v-list__tile--link.v-list__tile--avatar{
        height: 90px;
    }
    .v-list__tile__action.v-list__tile__action--stack{
        padding-top: 1.5rem;
    }
    .v-list>div:last-child .v-progress-linear{
        bottom:-9px!important;
    }
    .v-pagination{
        justify-content: center;
        display:flex
    }

    .v-list__tile__content{
      cursor:pointer;
    }
    .v-list__tile__content>a{
      text-decoration:none;color:inherit;
    }
    .v-progress-linear{
      position: absolute;left: 0;bottom: 0;margin:0;
    }
    .v-list__tile__avatar .v-avatar > .v-icon{
        font-size:2rem;
    }
</style>